import React, { useContext } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Joystick from '../components/Joystick'
import { sendTaskToRobot } from "../utils/ROS/ROSFunctions"
import { faCompass, faCaretLeft } from '@fortawesome/free-solid-svg-icons'
import Context from "../utils/Context"

//this components is the pause options, it has a joystick and a button to go to the base location

export default function PauseOptions(props) {
    const context = useContext(Context)

    const execLocation = () => {
        sendTaskToRobot({ actions: [{ value: "Base", name: "publish-pose" }], id: "Base", name: "PRIORITY" })
        context.actions.setMessage({ message: "Ok!", type: "success" })
    }

    const closeModal = () => {
        props.stopPauseHold()
        context.actions.setModalState({ ...context.modalState, activePause: !context.modalState.activePause })
    }

    return (
        <div className="columns">
            <div className="column">
                <button
                    onClick={closeModal}
                    className="button is-info is-light mb-5 mr-3"
                >
                    <FontAwesomeIcon icon={faCaretLeft} className="is-small mr-1" />
                    Back
                </button>

                <button
                    onClick={execLocation}
                    className="button is-info mb-5 mr-3"
                >
                    <FontAwesomeIcon icon={faCompass} className="is-small mr-1" />
                    Location
                </button>
            </div>

            <div className="column">
                <Joystick />
            </div>
        </div>
    )
}